// extracted by mini-css-extract-plugin
export default {"container":"RecentPlays_container__xbhTf","loadingSpinner":"RecentPlays_loadingSpinner__okSKi","rows":"RecentPlays_rows__+Trrg"};